module.exports = __webpack_public_path__ + "static/media/donation_program.5e6b9ef7.png";